<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!verificarPermissao('PERM_FICHA_CENTRAL_CLIENTE')">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="verificarPermissao('PERM_FICHA_CENTRAL_CLIENTE')">
			<h4>Ficha do Cliente</h4>
			<form *ngIf="cliente">
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>

						<div class="col-12 card-detalhe-cliente">
							<div class="formgroup">
								<div class="p-fluid p-formgrid grid">
									<div class="field col-12 md:col-12 margem-field">
										
										<label class="label-sem-borda-bottom mb-2">
											<i class="pi pi-user mr-1"></i>{{cliente.nome + ' - ' + cliente.apelido }}
										</label>
										
										<label class="form-control-sem-borda">
											<i class="pi pi-envelope mr-1"></i>{{cliente.email}}
										</label>
										<label class="form-control-sem-borda">
											<p *ngFor="let item of contatosClientes">
												<i class="pi pi-phone mr-1"></i>{{item.numero}}
											</p>
										</label>
									</div>
								</div>
							</div>
						</div>


						<div class="card col-12">
							<p-accordion>
								<p-accordionTab class="line-height-3 m-0">
									<ng-template pTemplate="header">
										<span class="flex align-items-center gap-2 w-full">

											<span class="font-bold white-space-nowrap">
												Avaliação (Anamnese)
											</span>
											<p-badge [value]="listaFichaDiagnosticoCliente.length.toString()"
												class="ml-auto mr-2">
											</p-badge>
										</span>
									</ng-template>
									<div class="col-12">
										<div class="grid p-fluid justify-content-end">
											<div class="col-12 md:col-4">
												<div class="flex justify-content-end">
													<div class="p-inputgroup">
														<span class="p-input-icon-left">
															<i class="pi pi-search"></i>
															<input pInputText type="text" placeholder="Buscar"
																name="inputBuscaAnamnese" class="w-full" />
														</span>
														<button type="button" pButton pRipple icon="pi pi-filter-slash"
															pTooltip="Limpar Filtros"></button>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class=" w-full mb-3" *ngFor="let item of listaFichaDiagnosticoCliente">
										<p-card>
											<div class="flex justify-content-start flex-column sm:flex-row">
												<div class="pt-2">
													<span *ngIf="!item.anamnese?.lgpd"
														class="product-badge bg-green-600 admihair-text-white">
														{{item.anamnese?.descricao}}
													</span>
													<span *ngIf="item.anamnese?.lgpd"
														class="product-badge bg-green-600 admihair-text-white">
														{{verificarTextoLgpd(item.anamnese?.descricao)}}
													</span>
												</div>
											</div>
											<div *ngFor="let subItem of item.diagnosticos" class="card-simple mt-3">
												<p>
													<i class="pi pi-calendar mr-1"></i><label>{{subItem.data |
														date:'dd/MM/yyy' + ': '}}</label>
													<label *ngIf="!subItem.lgpd">{{subItem.especificacao}}</label>
													<label
														*ngIf="subItem.lgpd">{{verificarTextoLgpd(subItem.especificacao)}}</label>
												</p>

												<div class="flex justify-content-start flex-column sm:flex-row">
													<p>
														<label *ngIf="subItem.observacao">
															<i class="pi pi-book mr-1"></i><label>Observação: </label>
															<label>{{subItem.observacao}}</label>
														</label>
													</p>
												</div>
											</div>
										</p-card>

									</div>
								</p-accordionTab>


								<p-accordionTab class="line-height-3 m-0">
									<ng-template pTemplate="header">
										<span class="flex align-items-center gap-2 w-full">

											<span class="font-bold white-space-nowrap">
												Informes
											</span>
											<p-badge [value]="listaRecados.length.toString()" class="ml-auto mr-2">
											</p-badge>
										</span>
									</ng-template>
									<div class="col-12">
										<div class="grid p-fluid justify-content-between">
											<div class="col-12 md:col-1">
												<button pButton class="p-button-primary" icon="pi pi-plus"
													pTooltip="Novo Recado" (click)="abrirDialogRecado()"></button>
											</div>
											<div class="col-12 md:col-4">
												<div class="flex justify-content-end">
													<div class="p-inputgroup">
														<span class="p-input-icon-left">
															<i class="pi pi-search"></i>
															<input pInputText type="text" placeholder="Buscar"
																name="inputBuscaRecado" class="w-full"
																(input)="filtrarMensagens()"
																[(ngModel)]="buscaRecado" />
														</span>
														<button type="button" pButton pRipple icon="pi pi-filter-slash"
															pTooltip="Limpar Filtros"
															(click)="limparBuscarMensagem()"></button>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="card-simple mb-3" *ngFor="let item of listaRecados; index as i">
										<div class="flex justify-content-start">
											<p>
												<label class="mr-2">
													<i class="pi pi-book mr-1"></i>
													<strong>{{'MENSAGEM ' + item.tipo}}</strong>
												</label>
												<label class="inline-flex align-items-center gap-1">
													<i class="pi pi-calendar mr-1"></i>
													{{item.data | date:'dd/MM/yyyy'}}
												</label>
											</p>
										</div>
										<div class="formgroup">
											<div class="p-fluid p-formgrid grid">
												<div class="field col-12 md:col-12 margem-field">
													<label class="form-control-sem-borda">
														{{item.descricao}}
													</label>
												</div>
												<div *ngIf="item.observacao"
													class="field col-12 md:col-12 margem-field">
													<label class="form-control-sem-borda">
														{{item.observacao}}
													</label>
												</div>
												<div class="field col-12 md:col-12 margem-field">
													<div class="flex justify-content-end">
														<button *ngIf="verificarUsuarioMensagem(item)" pButton
															class="w-3-rem sm:w-3rem h-3rem mr-2 p-button-danger"
															icon="pi pi-trash" pTooltip="Excluir"
															(click)="excluirMensagem(item.id)"></button>
														<button *ngIf="verificarUsuarioMensagem(item)" pButton
															class="w-3-rem sm:w-3rem h-3rem mr-2 p-button-success"
															icon="pi pi-pencil" pTooltip="Editar"
															(click)="editarMensagem(item)"></button>

													</div>
												</div>

											</div>
										</div>

									</div>

								</p-accordionTab>

								<p-accordionTab class="line-height-3 m-0">
									<ng-template pTemplate="header">
										<span class="flex align-items-center gap-2 w-full">
											<span class="font-bold white-space-nowrap">
												Histórico
											</span>
										</span>
									</ng-template>

									<div class="col-12">
										<div class="grid p-fluid justify-content-end">
											<div class="col-12 md:col-4">
												<div class="flex justify-content-end">
													<div class="p-inputgroup">
														<span class="p-input-icon-left">
															<i class="pi pi-search"></i>
															<input pInputText type="text" placeholder="Buscar"
																name="inputFiltroHistorico" class="w-full"
																(input)="filtrarHistorico()"
																[(ngModel)]="buscaHistorico" />
														</span>
														<button type="button" pButton pRipple icon="pi pi-filter-slash"
															pTooltip="Limpar Filtros"
															(click)="limparBuscaHistorico()"></button>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div class="card-simple mb-3" *ngFor="let item of listaHistoricoCliente">
										<p>
											<label>
												<i class="pi pi-fw pi-slack mr-1"></i>
												<strong>{{item.descricaoItem}}</strong>
											</label>
											<label> - </label>
											<label class="ml-2">
												<i class="pi pi-calendar mr-1"></i>
												{{item.data | date:'dd/MM/yyyy'}}
											</label>
										</p>


										<div class="formgroup">
											<div class="p-fluid p-formgrid grid">
												<div class="field col-12 md:col-3 margem-field">
													<label class="label-sem-borda-bottom">
														Profissional
													</label>
													<label class="form-control-sem-borda">
														<i class="pi pi-user mr-1"></i>{{item.nomeProfissional}}
													</label>
												</div>
												<div class="field col-12 md:col-3 margem-field">
													<label class="label-sem-borda-bottom">
														Valor Unitário
													</label>
													<label class="form-control-sem-borda">
														<i class="pi pi-money-bill mr-1"></i>{{'' + item.valorUnitario |
														currency:'BRL'}}
													</label>
												</div>
												<div class="field col-12 md:col-3 margem-field">
													<label class="label-sem-borda-bottom">
														Quantidade
													</label>
													<label class="form-control-sem-borda">
														<i class="pi pi-shopping-cart mr-1"></i>{{item.quantidade}}
													</label>
												</div>
												<div class="field col-12 md:col-3 margem-field">
													<label class="label-sem-borda-bottom">
														Valor Cobrado
													</label>
													<label class="form-control-sem-borda">
														<i class="pi pi-money-bill mr-1"></i>{{' ' + item.valorCobrado |
														currency:'BRL'}}
													</label>
												</div>

											</div>
										</div>

									</div>
								</p-accordionTab>
							</p-accordion>
						</div>

					</div>

					<div class="p-fluid p-formgrid grid justify-content-end">
						<div class="field col-12 md:col-2">
							<!-- <button type="button"  pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-primary mt-5" routerLink="/apps/central-cliente"></button> -->
						</div>
					</div>

				</div>

			</form>




			<p-dialog header="Recados" [(visible)]="exibirDialogRecado" [modal]="true" [style]="{width: '50rem'}"
				[breakpoints]="{'960px': '75vw', '640px': '90vw'}" [draggable]="false" [resizable]="false"
				[closable]="true">
				<form #formRecados="ngForm" name="formRecados">
					<div class="formgroup">
						<div class="p-fluid p-formgrid grid">
							<div class="field col-12 md:col-12">
								<label htmlFor="tipo">Tipo</label>
								<p-dropdown [options]="tiposMensagemCliente" placeholder="Selecione"
									emptyFilterMessage="Nenhum registro" name="tipo" ngModel #tipo="ngModel"
									[(ngModel)]="tipoMensagemSelecionada">
								</p-dropdown>
							</div>

							<div class="field col-12 md:col-12">
								<label htmlFor="descricao">Descrição</label>
								<textarea name="descricaoRecado" ngModel #descricaoRecado="ngModel" rows="5" cols="30"
									pInputTextarea [(ngModel)]="recadoCliente.descricao"></textarea>
							</div>
							<div class="field col-12 md:col-10">
								<label htmlFor="observacao">Observação</label>
								<textarea name="observacaoRecado" ngModel #observacaoRecado="ngModel" rows="5" cols="30"
									pInputTextarea [(ngModel)]="recadoCliente.observacao"></textarea>
							</div>
							<div class="field col-12 md:col-2">
								<label for="prioridade">Prioridade
								</label>
								<br />
								<p-inputSwitch name="prioridade" [(ngModel)]="recadoCliente.prioridade">
								</p-inputSwitch>
							</div>
						</div>
					</div>
				</form>



				<div class="w-full">
					<p-divider></p-divider>
				</div>
				<div class="p-fluid p-formgrid grid justify-content-between">
					<div class="field col-12 md:col-4" style="padding-bottom: 0px; margin-bottom: 0px">
						<button type="button" pButton [icon]="loadingRecado ? 'pi pi-spin pi-spinner':'pi pi-check'"
							[label]="!modoEditarRecado ? 'Salvar':'Atualizar'" class="p-button-success"
							[disabled]="loadingRecado" (click)="salvarRecado()">
						</button>
					</div>
					<div class="field col-12 md:col-4" style="padding-bottom: 0px; margin-bottom: 0px">
						<button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-primary"
							(click)="exibirDialogRecado = false" [disabled]="loadingRecado"></button>
					</div>
				</div>

			</p-dialog>
			<p-confirmDialog [style]="{width: '50vw'}">
			</p-confirmDialog>



		</div>
	</div>
</div>